export default __webpack_public_path__ + "static/media/toggle-down-icon.38fbeb01.svg";